// The deck the sign-in showcase cycles through on an App Kit instance:
// what this app can do and where to find it. Static on purpose — the kit
// frontend has no console catalog; every card names a real route in App.js.
// Layers may replace the list by passing `insights` to <AuthShell>.
export const AUTH_INSIGHTS = [
  {
    kind: 'feature',
    kicker: 'nQube · Pipelines',
    title: 'Design the workflow once. The runtime enforces it.',
    body: 'Pipelines are drawn as blocks — inputs, model steps, filters, human review, outputs. A model step can propose a write; only a gate that is not a model lets the runtime commit it.',
  },
  {
    kind: 'tip',
    kicker: 'Tip · Review',
    title: 'Approve, edit or reject from one queue',
    body: 'Review lists every step a gate paused. Open an item, read the context the pipeline attached, and decide — the decision is recorded with the run.',
  },
  {
    kind: 'feature',
    kicker: 'Agents',
    title: 'Named assistants with a written boundary.',
    body: 'Each agent has a voice (name, greeting, instructions), the records it may read, and the creates it may propose. Toggles, not a paragraph in the prompt.',
  },
  {
    kind: 'tip',
    kicker: 'Tip · Uploads',
    title: 'Large files go straight to storage',
    body: 'Browsers upload directly to the bucket in resumable parts — no size ceiling from the app server. Guest drop links let outside people send files without an account.',
  },
  {
    kind: 'feature',
    kicker: 'Jobs',
    title: 'Heavy work fans out, and you can watch it.',
    body: 'Long processing splits across short-lived runners. Jobs shows each task\'s progress and lets you pause, resume or cancel a run while it is in flight.',
  },
  {
    kind: 'tip',
    kicker: 'Tip · Team',
    title: 'Workspaces segregate inside the organization',
    body: 'Team manages members, workspaces and seats — viewer, member, admin, owner. Records carry their workspace, and the data rules enforce it before any screen does.',
  },
  {
    kind: 'feature',
    kicker: 'Mail',
    title: 'An inbox on the app\'s own domain.',
    body: 'Mailboxes, threads and send live inside the app, through the same seam whether the instance is managed or self-hosted.',
  },
  {
    kind: 'tip',
    kicker: 'Tip · Dev Console',
    title: 'Ask for a change, read the diff, ship it',
    body: 'At /dev an agent works this instance\'s layer repository. You review the diff, open a preview, then deploy frontend, backend or rules — UAT first, production as a promote.',
  },
];
